import { createBrowserRouter, Navigate } from 'react-router-dom'
import AuthGuard from 'routers/AuthGuard'
import RouteGuard from 'routers/RouteGuard'
import EnquiryForm from 'pages/help/Help'
import WalletPage from 'pages/wallet/wallet/wallet'
import ViewTransaction from 'pages/wallet/wallet/ViewTransaction'
import EnquiriesList from 'pages/help/EnquiryList'
import ChannelOnboardingDetails from '../pages/channelOnBoarding/channelOnboardingList/ChannelOnboardingDetails'
import RootLayout from '../layouts/RootLayout'
import AuthLayout from '../layouts/AuthLayout'
import LoginPage from '../pages/login/Login'
import LogoutPage from '../pages/login/Logout'
import Dashboardpage from '../pages/Dashboard/dashboard'
import ChannelType from '../pages/channelOnBoarding/channelType/ChannelType'
import Templatepage from '../pages/template/templateList/TemplateList'
import Campaignpage from '../pages/camapaign/campaignList/campaignList'
import Profilepage from '../pages/profile/profile/Profile'
import Audience from '../pages/audience/audienceList/AudienceList'
import CompanyList from '../pages/documentVerification/companyList/CompanyList'
import DocumentsPage from '../pages/documentVerification/documents/Documents'
import { ROUTES } from './Routes'

const appRouter = () =>
  createBrowserRouter([
    {
      element: <RootLayout />,
      children: [
        {
          path: '/auth',
          element: <LoginPage />
        },
        {
          path: '/logout',
          element: <LogoutPage />
        },
        {
          path: '*',
          element: <Navigate to="/auth" replace />
        },

        {
          element: (
            <AuthGuard>
              <AuthLayout />
            </AuthGuard>
          ),
          children: [
            {
              path: '/',

              element: (
                <RouteGuard requiredRoles={['ROLE_USER', 'ROLE_ADMIN']}>
                  <Dashboardpage />
                </RouteGuard>
              )
            },

            {
              path: '/campaigns',
              element: (
                <RouteGuard requiredRoles={['ROLE_USER', 'ROLE_ADMIN']}>
                  <Campaignpage />
                </RouteGuard>
              )
            },
            {
              path: '/templates',
              element: (
                <RouteGuard requiredRoles={['ROLE_USER', 'ROLE_ADMIN']}>
                  <Templatepage />
                </RouteGuard>
              )
            },
            {
              path: '/wallet',
              element: (
                <RouteGuard requiredRoles={['ROLE_USER', 'ROLE_ADMIN']}>
                  <WalletPage />
                </RouteGuard>
              )
            },
            {
              path: '/wallet/transaction',
              element: (
                <RouteGuard requiredRoles={['ROLE_USER', 'ROLE_ADMIN']}>
                  <ViewTransaction />
                </RouteGuard>
              )
            },

            {
              path: '/channels',
              element: (
                <RouteGuard requiredRoles={['ROLE_USER', 'ROLE_ADMIN']}>
                  <ChannelType />
                </RouteGuard>
              )
            },
            {
              path: '/channels/:globalname',
              element: (
                <RouteGuard requiredRoles={['ROLE_USER', 'ROLE_ADMIN']}>
                  <ChannelOnboardingDetails />
                </RouteGuard>
              )
            },

            {
              path: '/audience',
              element: (
                <RouteGuard requiredRoles={['ROLE_USER', 'ROLE_ADMIN']}>
                  <Audience />
                </RouteGuard>
              )
            },
            {
              path: '/help',
              element: (
                <RouteGuard requiredRoles={['ROLE_USER']}>
                  <EnquiryForm />
                </RouteGuard>
              )
            },
            {
              path: '/profile',
              element: (
                <RouteGuard requiredRoles={['ROLE_USER', 'ROLE_ADMIN']}>
                  <Profilepage />
                </RouteGuard>
              )
            },
            {
              path: '/enquiry',
              element: (
                <RouteGuard requiredRoles={['ROLE_ADMIN']}>
                  <EnquiriesList />
                </RouteGuard>
              )
            },
            {
              path: ROUTES.COMPANY_LIST,
              element: (
                <RouteGuard requiredRoles={['ROLE_ADMIN']}>
                  <CompanyList />
                </RouteGuard>
              )
            },
            {
              path: ROUTES.COMPANY_DOCUMENTS,
              element: (
                <RouteGuard requiredRoles={['ROLE_ADMIN']}>
                  <DocumentsPage />
                </RouteGuard>
              )
            }
          ]
        }
      ]
    }
  ])

export default appRouter
